import styled from 'styled-components'
import { FormControl } from 'react-bootstrap'

const TableSearch = styled(FormControl)`
  margin-bottom: 10px;
`
export default TableSearch
